import Box from "@mui/material/Box";
import { useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import Alert from "@mui/material/Alert";
import { emailRegex } from "../../utils/regex";

export default function EditUserModal({
  user,
  accessLevels,
  refreshUsers,
  handleClose,
}) {
  const url = process.env.REACT_APP_URL;
  //Add user state
  const [username, setUsername] = useState(user.userName);
  const [email, setEmail] = useState(user.email);
  const [userLevel, setUserLevel] = useState(user.userLevel);
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshUsers();
      }
    }, duration);
  };

  const handleValidation = () => {
    setDisable(true);
    if (username === "") {
      handleAlert("Please enter a username", "warning");
    } else if (email === "" || !email.match(emailRegex)) {
      handleAlert("Please enter a valid email", "warning");
    } else if (userLevel === 0) {
      handleAlert("Please select a user level", "warning");
    } else {
      handleEditUser();
    }
  };

  const handleEditUser = async () => {
    const reqBody = {
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
      userId: user.userId,
      username: username.trim(),
      email: email,
      userLevel: userLevel,
    };

    await axios
      .post(`${url}/users/update-user`, reqBody)
      .then((res) => {
        handleAlert("User Successfully Updated", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - please try again", "error");
      });
  };

  const blockUser = async () => {
    const reqBody = {
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
      userId: user.userId,
      username: username.trim(),
    };

    await axios.post(`${url}/user`)
  };

  return (
    <Box className="edit-user-modal">
      {!user.blocked ? (
        <Button
          className="block-user-btn"
          variant="contained"
          color="error"
          onClick={blockUser}
        >
          Block User
        </Button>
      ) : null}
      <section className="edit-user-section">
        <h2>Edit User</h2>
        <form className="edit-user-form">
          <div className="form-input">
            <label>Username</label>
            <input
              value={username}
              placeholder="Enter Username"
              type="text"
              onChange={(e) => setUsername(e.target.value)}
              maxLength={20}
            />
          </div>
          <div className="form-input">
            <label>Email</label>

            <input
              value={email}
              placeholder="Enter Email"
              type="text"
              onChange={(e) => setEmail(e.target.value)}
              maxLength={50}
            />
          </div>
          <div className="form-input">
            <label>User Level</label>
            <select
              value={userLevel}
              onChange={(e) => {
                setUserLevel(parseInt(e.target.value));
              }}
            >
              <option value={0}>Select a user level</option>
              {accessLevels && accessLevels.length > 0
                ? accessLevels.map((level) => {
                    return (
                      <option value={level.levelId}>{level.levelType}</option>
                    );
                  })
                : null}
            </select>
          </div>
        </form>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            variant="contained"
            color="error"
            onClick={() => handleClose(false)}
            disabled={disable}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={disable}
            onClick={handleValidation}
          >
            Update
          </Button>
        </section>
      </section>
    </Box>
  );
}
